import model from "@js/model.js";

export default function(dynamicImportPromise, global){
    if(typeof global !== 'boolean') global = true;
    return new Promise(resolve => {
        if(global){
            model.dynamicImports++;
            model.dispatchEvent('ShowPreloader');
        }
        dynamicImportPromise().then(result => {
            if(global){
                model.dynamicImports--;
                model.dispatchEvent('HidePreloader');
            }
            resolve(result);
        });
    });
};